module.exports = __webpack_public_path__ + "static/media/libro3.8169f4ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/libro3.png
// module id = 351
// module chunks = 0